module.exports = __webpack_public_path__ + "img/ex-about-us.a2a90797.jpg";